import React from 'react'
import styles from './ManagerRow.module.scss'

const ManagerRow = ({
  name,
  progress,
  target,
  limit,
  translate,
  targetProgress,
  sortedGoal,
  flag,
}) => {
  const percentage = target ? Math.min((progress / target) * 100, 100) : 0
  const color = progress >= limit ? '#1ABC97' : '#FF0022'
  const backgroundColor = color === '#FF0022' ? '#FFDDD5' : '#EAFFF8'

  return (
    <div className={styles.managerRow}>
      <div className={styles.name}>{name}</div>
      <div className={styles.progressBar}>
        {flag}
        <div
          className={`${styles.progress} ${color}`}
          style={{
            width: `${percentage}%`,
            backgroundColor: color,
          }}
        ></div>
        <div
          className={`${styles.ingoing} ${color}`}
          style={{
            width: `${100 - percentage}%`,
            backgroundColor:
              percentage >= 0 && target ? backgroundColor : '#F0F3F5',
          }}
        >
          {!target ? (
            <div className={styles.progressNull}>{translate.no_goal_set}</div>
          ) : (
            <div className={styles.progress}>
              <div className={styles.textProgress}>
                {progress >= target ? '' : targetProgress}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={styles.values}>{target ? sortedGoal : `0₸`}</div>
    </div>
  )
}

export default ManagerRow
